import { Injectable } from "@angular/core";

import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { PagingRequest } from "../../models/domains/paginator/paging-request";
import { TherapeuticClassRepository } from "../../repositories/pbm/therapeutic-class.repository";

@Injectable({ providedIn: "root" })
export class TherapeuticClassService {
  constructor(private therapeuticClassRepository: TherapeuticClassRepository) {}

  public async searchTherapeuticClassProductsBy(pagingRequest: PagingRequest): Promise<PageableResult> {
    return await this.therapeuticClassRepository.searchTherapeuticClassProductsBy(pagingRequest);
  }
}
